import { render, staticRenderFns } from "./AnalisePorCliente.vue?vue&type=template&id=cef91756"
import script from "./AnalisePorCliente.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalisePorCliente.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports